export interface PaginatedSource<T> {
  items: Array<T> | null;
  nextToken?: string;
}

export interface Company {
  id: string;
  name: string;
  email: string;
  locations?: PaginatedSource<Location>;
  updatedAt: string;
  settings: CompanySettings;
}

export interface Employee {
  locationId: string;
  location?: Location;
  insuranceNumber: string;
  patient?: PatientInformation;
  address?: Address;
  identifier: Identifier;
  birthdate?: string;
  expiresAt: number;
}

export interface CompanySettings {
  hasSelfTests: boolean;
  defaultSelfTests?: number;
}
export type Address = {
  __typename: "Address";
  street: string;
  number: string;
  city: string;
  zip: string;
  country?: string | null;
};

export type Location = {
  id: string;
  companyId: string;
  name: string;
  createdAt?: string;
  updatedAt?: string;
  phone?: string;
  email?: string;
  locationId: string;
  address?: Address;
  healthDepartmentEmail?: string;
  healthDeparmentNumber?: string;
  enableAutoEmail?: boolean;
};

export type TestResult = "positiv" | "negativ" | "invalid";
export type Identifier = "insurance" | "passport" | "identity_card";
export enum TestType {
  test_antigen = "test_antigen",
  self_test_antigen = "self_test_antigen",
  test_pcr = "test_pcr",
  test_distribution = "test_distribution",
  test_citizen = "test_citizen",
}

export interface TestDocumentation {
  type: TestType;
  reason?: string;
  paymentRequired?: boolean;
  noPaymentRequiredProof?: string;
  paymentRecived?: boolean;
}
export interface BaseTestId {
  testId: string;
  date: string;
}

export interface GraphPoint {
  data: number;
  label: string;
}
export interface AnalyticsListEntry {
  locationId: string;
  invalid?: number;
  positiv?: number;
  negativ?: number;
}

export interface Test extends BaseTestId {
  testId: string;
  companyId: string;
  locationId: string;
  date: string;
  userId: string;
  patient: PatientInformation;
  company: Company;
  location: Location;
  createdAt?: string;
  updatedAt?: string;
  result: TestResult;
  issuedSelfTests?: number;
  qrGenerated?: boolean;
  resendTest?: boolean;
  dataPrivacyAccepted: boolean;
  identifier: Identifier;
  documentation?: TestDocumentation | null;
}

export interface SendInformation extends BaseTestId {
  sent: boolean;
}

export interface CreateTest {
  testId: string;
  companyId: string;
  locationId: string;
  date: string;
  userId: string;
  patient: PatientInformation;
}

export type PatientInformation = {
  firstname: string;
  lastname: string;
  insuranceNumber: string;
  email?: string;
  address?: Address;
  birthdate?: string;
  addressString?: string;
};

export interface User {
  username: string;
  groups: Array<string>;
  state?: "Enabled" | "Disabled";
}
